import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

@Index('goal_preferences_unique', ['entityType', 'entityId', 'goal'], {
	unique: true,
})
@Index('idx_goal_preferences_deleted', ['deletedDate'], {})
@Index('idx_goal_preferences_entity', ['entityType', 'entityId'], {})
@Entity('goal_preferences')
export class GoalPreferencesEntity extends BaseEntity {
	@Column('varchar', { name: 'goal', nullable: false, length: 50 })
	public goal!: string;

	@Column('enum', { name: 'entity_type', enum: ['user', 'team', 'company'] })
	public entityType!: 'user' | 'team' | 'company';

	@Column('int', { name: 'entity_id', unsigned: true })
	public entityId!: number;
}
